import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Memorial from '../views/Memorial.vue'
import Brand from '../views/Brand.vue'
import Shop from '../views/Shop.vue'
import Story from '../views/Story.vue'
import Privacy from '../views/Privacy.vue'
import Legal from '../views/Legal.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/memorial',
    name: 'Memorial',
    component: Memorial
  },
  {
    path: '/memorial/:category',
    name: 'MemorialCategory',
    component: Memorial
  },
  {
    path: '/brand',
    name: 'Brand',
    component: Brand
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop
  },
  {
    path: '/story',
    name: 'Story',
    component: Story
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/legal',
    name: 'Legal',
    component: Legal
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    return { top: 0 }
  }
})

export default router
